import React from "react";

import {useTranslation} from "react-i18next";
import DOMPurify from "dompurify";

const ContactUs: React.FC<any> = (props) => {
    const {t} = useTranslation();
    return (
        <>
            <div className="contact-page w-full">
                {/* Map Section */}
                <section className="map-section bg-white p-7 px-4 py-6 md:p-7 lg:pb-14">

                    <div className="map-container rounded-lg overflow-hidden shadow-md">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.827853098681!2d144.9537657!3d-37.81797!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad65d4e12b8f223%3A0xfdcb4dbc0a23fd46!2s4%2F601%20Little%20Collins%20St%2C%20Docklands%20VIC%203008%2C%20Australia!5e0!3m2!1sen!2sus!4v1712345678901!5m2!1sen!2sus"
                            width="100%"
                            height="300" // Reduced height for mobile
                            className="md:h-[450px]" // Larger height on desktop
                            style={{border: 0}}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            aria-label="Our location on Google Maps"
                        />
                    </div>
                </section>

                {/* Contact Info Section */}
                <section className="contact-info bg-white px-4 py-6 md:p-6">
                    <div className="container mx-auto">
                        <div className="contact-grid">
                            <div className="contact-item mb-8 md:mb-16 xl:mb-32">
                                <div className="contact-content mt-4 md:mt-8 lg:ml-8 xl:ml-16">
                                    <h3 className="contact-title text-secondary text-xl md:text-2xl xl:text-3xl 4xl:text-5xl font-primary mb-4">
                                        {t('contact:contact')}
                                    </h3>
                                    <div className="space-y-3">
                                        <p className="text-base md:text-xl">{t('contact:address')}</p>
                                        <p className="text-base md:text-xl">{t('contact:abn')}</p>
                                        <div
                                            className="text-base md:text-xl font-bold text-secondary"
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(t('contact:email'))
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    )
}

export default ContactUs;